import { cn } from '../../lib/utils';
import { Check } from 'lucide-react';

const defaultSteps = [
  { key: 'created', label: 'Created' },
  { key: 'assigned', label: 'Assigned' },
  { key: 'in_progress', label: 'In Progress' },
  { key: 'verified', label: 'Verified' },
  { key: 'qc', label: 'QC' },
  { key: 'completed', label: 'Completed' },
  { key: 'report_sent', label: 'Report Sent' },
];

export const StatusTracker = ({ currentStep = 0, steps = defaultSteps, className }) => {
  return (
    <div className={cn('status-tracker', className)} data-testid="status-tracker">
      {steps.map((step, index) => {
        const isCompleted = index < currentStep;
        const isCurrent = index === currentStep;
        const isPending = index > currentStep;

        return (
          <div
            key={step.key}
            className={cn(
              'status-step',
              isCompleted && 'completed',
              isCurrent && 'current',
              isPending && 'pending'
            )}
            data-testid={`status-step-${step.key}`}
          >
            <div className="status-step-dot">
              {isCompleted ? (
                <Check className="w-4 h-4" />
              ) : (
                <span>{index + 1}</span>
              )}
            </div>
            <span className="status-step-label">{step.label}</span>
            {index < steps.length - 1 && <div className="status-step-line" />}
          </div>
        );
      })}
    </div>
  );
};

export default StatusTracker;
